import { Switch } from 'antd'
import CustomModal from 'components/global/CustomModal'
import CustomModalFooter from 'components/global/CustomModalFooter'
import React from 'react'
import { RequiredDeatilsTypes } from 'types/event/eventStep5'

interface RequiredDetailProps {
  openModal: boolean
  closeModal:
    | React.Dispatch<React.SetStateAction<boolean>>
    | ((state: boolean) => void)
  requiredDetails: any
  setRequiredDetails: any
}

const RequiredDetailsModal: React.FC<RequiredDetailProps> = ({
  openModal,
  closeModal,
  requiredDetails,
  setRequiredDetails,
}) => {
  const hanldeSwitchClick = (
    item: RequiredDeatilsTypes,
    type: 'guardian' | 'adult' | 'kid',
  ) => {
    const updateDetails = (list: RequiredDeatilsTypes[]) => {
      return list.map(entry => {
        return entry.key === item.key
          ? { ...entry, value: !entry.value }
          : entry
      })
    }
    let updatedDetails
    if (type === 'guardian') {
      updatedDetails = { guardians: updateDetails(requiredDetails.guardians) }
    } else if (type === 'adult') {
      updatedDetails = { adults: updateDetails(requiredDetails.adults) }
    } else if (type === 'kid') {
      updatedDetails = { kids: updateDetails(requiredDetails.kids) }
    }

    setRequiredDetails({ ...requiredDetails, ...updatedDetails })
  }

  return (
    <>
      <CustomModal
        openModal={openModal}
        closeModal={closeModal}
        title="Required Details"
        footer={
          <CustomModalFooter
            multibutton={false}
            btnAlignment="justify-end"
            btnText="Save"
            btnType="primary"
            onSubmit={() => closeModal(false)}
          />
        }
      >
        <div className="mt-15px">
          <p>
            Select what input fileds shoudl be mandatory at the event
            registration
          </p>
          <div className="">
            <div className="mt-10px">
              <h3 className="text-16 w-600">Parent details</h3>
              <div>
                {requiredDetails.guardians.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className="flex align-center justify-between py-10px border-btm"
                    >
                      <p>{item.title}</p>
                      <Switch
                        checked={item.value}
                        onChange={() => hanldeSwitchClick(item, 'guardian')}
                      />
                    </div>
                  )
                })}
              </div>
            </div>
            <div className="mt-10px">
              <h3 className="text-16 w-600">Adult details</h3>
              <div>
                {requiredDetails.adults.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className="flex align-center justify-between py-10px border-btm"
                    >
                      <p>{item.title}</p>
                      <Switch
                        checked={item.value}
                        onChange={() => hanldeSwitchClick(item, 'adult')}
                      />
                    </div>
                  )
                })}
              </div>
            </div>
            <div className="mt-10px">
              <h3 className="text-16 w-600">Kid details</h3>
              <div>
                {requiredDetails.kids.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className="flex align-center justify-between py-10px border-btm"
                    >
                      <p>{item.title}</p>
                      <Switch
                        checked={item.value}
                        onChange={() => hanldeSwitchClick(item, 'kid')}
                      />
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </CustomModal>
    </>
  )
}

export default RequiredDetailsModal
